import { PlanFeatureMessage } from "@/components/wpl/pricing/src/price-finder/constants.tsx";
import {
    ContentPlatformHighlightedFeature,
    PricingPlanComparison
} from "@/utils/pricing-queries/get-pricing-content";

export const createFeatureMessages = (
    highlightedFeatures: ContentPlatformHighlightedFeature[]
): PlanFeatureMessage[] => {
    return highlightedFeatures.map(
        (highlight) =>
            ({
                featureMessage: highlight.highlightedFeatureDetails
                    ? {
                          text: highlight.highlightedFeatureTitleExternal as string,
                          content: () => (
                              <div
                                  dangerouslySetInnerHTML={{
                                      __html: highlight.highlightedFeatureDetails as string
                                  }}
                              />
                          )
                      }
                    : (highlight.highlightedFeatureTitleExternal as string),
                lozengeText: highlight.callOut
            } as PlanFeatureMessage)
    );
};

export const createPlanFeatureMessages = <
    T extends Record<string, PricingPlanComparison | undefined>
>(
    content: T,
    planKey: keyof T
) => {
    const plan = content?.[planKey];
    return plan?.highlightedFeaturesContainer
        ? createFeatureMessages(plan.highlightedFeaturesContainer)
        : [];
};
